import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rpc-unhandled-error',
  templateUrl: './unhandled-error.component.html',
  styleUrls: ['./unhandled-error.component.scss']
})
export class UnhandledErrorComponent {}
